<template>
  <VView class="about" back-button-to="/menu" :header="$t('about.header')">
    <VText>Produkty dickie toys dostarczą WAM wielu niezapomnianych wrażeń podczas zabawy!</VText>

    <VMedia class="about__picture"><img src="@/assets/banner-1.png" /></VMedia>
    <!-- <VText><small>Go Real Construction to <span>realistyczne reprodukcje</span> pojazdów budowlanych, które można spotkać na placu budowy. Znajdziesz tu między innym <span>koparki, wywrotki, ładowarki, dźwigi i wiele innych.</span></small></VText> -->
    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton href="https://www.humbi.pl/ser-pol-72-Dickie-Construction.html?utm_source=simba&utm_medium=display" target="_blank" special>Sprawdź!</VButton>
      </transition>
    </VButtonGroup>

    <VMedia class="about__picture"><img src="@/assets/banner-2.png" /></VMedia>
    <!-- <VText><small>Go Real Police/Fire&amp;Rescue to <span>realistyczne reprodukcje</span> pojazdów i marek znanych wszystkim z codziennego życia. Znajdziesz tu między innym <span>wozy strażackie, kwatery i wozy policyjne, karetki i wiele innych.</span></small></VText> -->
    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton href="https://brykacze.pl/zabawki-dickie/27" target="_blank" special>Sprawdź!</VButton>
      </transition>
    </VButtonGroup>

    <VMedia class="about__picture"><img src="@/assets/banner-3.png" /></VMedia>
    <!-- <VText><small>Go Action City Heroes to <span>pojazdy pełne akcji,</span> dzięki którym odkryjesz w sobie niespotykaną do tej pory <span>pomysłowość w zabawie.</span></small></VText> -->
    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton href="https://krainazabawy.pl/2-glowna/s-1/producent-dickie" target="_blank" special>Sprawdź!</VButton>
      </transition>
    </VButtonGroup>

    <VMedia class="about__picture"><img src="@/assets/banner-4.png" /></VMedia>
    <!-- <VText><small>GO CRAZY TO <span>Szalone pojazdy,</span> które są zawsze gotowe na kolejną przygodę! Z samochodami z tej linii <span>nie ma czasu na nudę!</span> Jeżeli masz w sobie choć odrobinę szaleńStwa to jest to seria idealna dla Ciebie.</small></VText> -->
    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton href="https://www.empik.com/marka/dickie?searchCategory=376807&utm_source=LPkonkursowy&utm_medium=website" target="_blank" special>Sprawdź!</VButton>
      </transition>
    </VButtonGroup>

    <VText center>
      Czy to już czas na wzięcie udziału w naszym konkursie?<br />
      Walcz o lot w tunelu aerodynamicznym lUb o pojazdy budowlane od dickie toys!
    </VText>

    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton to="/contest" special>Laureaci</VButton>
      </transition>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VMedia from '@/components/VMedia.vue';
import VText from '@/components/VText.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'About',
  components: {
    VView,
    VMedia,
    VText,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss" scoped>
.about {
  &__picture {
    margin: 50px -50px 0;

    @media screen and (max-width: 800px) {
      margin: 50px -20px 0;
    }
  }

  ::v-deep .text:not(:first-child) {
    margin-top: 80px;
  }

  &__picture + ::v-deep .button-group {
    margin: -5% auto 50px;
  }
}
</style>
